<template>
  <div>
    <v-row v-if="isEditing">
      <v-col cols="12">
        <v-autocomplete
          :items="trainingCategories"
          :value="selectedTrainingCategory"
          @input="handleTrainingCategoryInput"
          full-width
          return-object
          item-value="_id"
          flat
          :hint="$t('course.courseDetails.selectCategory')"
          persistent-hint
          dense
          outlined
          hide-selected
          :loading="loading"
          :disabled="!trainingCategories.length"
          :filter="customLocalisedAutoCompleteFilter"
          background-color="transparent"
          class="rounded-lg textLight--text"
        >
          <template v-slot:selection="{ item }">
            {{ getLocalisedValue(item.name) }}
          </template>

          <template v-slot:item="{ item }">
            {{ getLocalisedValue(item.name) }}
          </template>
        </v-autocomplete>
      </v-col>

      <v-col
        v-if="trainingCategories.length && selectedTrainingCategory"
        cols="12"
      >
        <v-autocomplete
          :items="getTrainingSubCategories(selectedTrainingCategory)"
          :value="selectedTrainingSubCategory"
          @input="handleTrainingSubCategoryInput"
          full-width
          return-object
          item-value="_id"
          flat
          solo
          :hint="$t('course.courseDetails.selectSubCategory')"
          persistent-hint
          dense
          outlined
          hide-selected
          :filter="customLocalisedAutoCompleteFilter"
          background-color="transparent"
          class="rounded-lg textLight--text"
        >
          <template v-slot:selection="{ item }">
            {{ getLocalisedValue(item.name) }}
          </template>

          <template v-slot:item="{ item }">
            {{ getLocalisedValue(item.name) }}
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row v-else-if="selectedTrainingCategory">
      <v-col>
        <span class="subtitle-1 font-weight-medium primaryDark--text">
          {{
            getLocalisedValue(
              getTrainingCategory(selectedTrainingCategory).name
            )
          }}

          {{
            selectedTrainingSubCategory
              ? `| ${getLocalisedValue(
                  getTrainingSubCategory(selectedTrainingSubCategory).name
                )}`
              : ""
          }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CourseCategory",
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      trainingCategories: [],
      selectedTrainingCategory: null,
      selectedTrainingSubCategory: null,
    };
  },
  apollo: {
    getTrainingCategories() {
      return {
        query: require("../../../category-module/api/query/getTrainingCategories.gql"),
        variables: { pageInput: { skip: 0, limit: 0 } },
        result({ data, loading }) {
          if (data?.getTrainingCategories?.trainingCategories) {
            this.trainingCategories =
              data?.getTrainingCategories?.trainingCategories
                ?.filter(x => x.isActive === true)
                ?.map(xs => {
                  return {
                    ...xs,
                    subCategories: xs.subCategories?.filter(
                      x => x.isActive === true
                    ),
                  };
                }) ?? [];
          }

          this.loading = loading;
        },
      };
    },
  },
  watch: {
    training: {
      handler() {
        if (this.training.trainingCategories?.length) {
          this.selectedTrainingCategory = this.training.trainingCategories[0];
        }

        if (this.training.trainingSubCategories?.length) {
          this.selectedTrainingSubCategory =
            this.training.trainingSubCategories[0];
        }
      },
      immediate: true,
    },
  },
  methods: {
    getTrainingCategory(trainingCategory) {
      return (
        this.trainingCategories?.find(x => x._id === trainingCategory?._id) ??
        {}
      );
    },
    getTrainingSubCategory(trainingSubCategory) {
      return (
        this.getTrainingSubCategories(this.selectedTrainingCategory)?.find(
          x => x._id === trainingSubCategory?._id
        ) ?? {}
      );
    },
    getTrainingSubCategories(trainingCategory) {
      return this.getTrainingCategory(trainingCategory)?.subCategories ?? [];
    },
    handleTrainingCategoryInput(value) {
      this.$emit("update:training", {
        ...this.training,
        trainingCategories: [value],
        trainingSubCategories: [],
        hasChangesInTrainingCategories: true,
      });
    },
    handleTrainingSubCategoryInput(value) {
      this.$emit("update:training", {
        ...this.training,
        trainingSubCategories: [value],
        hasChangesInTrainingSubCategories: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped />
